import React from 'react'
import useQuery from '../useQuery'
import GetScansWidget from './GetScansWidget'
import GetTagsForScansWidget from './GetTagsForScansWidget'

import { parseAsNumber } from '../../../utils/parse'

const PALETTE = ['#C23DFF', '#45E0D3', '#B7F731', '#FFC226', '#FF297E']

const parseQueryParams = ({ e, mode, day }) => {
    const DEFAULT_TAG = {
        id: 3,
        label: 'Ticket Type',
    }

    const DEFAULT_MODE = {
        id: 1,
        label: 'Cumulative',
    }

    const defaultOrParseAsInt = (value, defaultIfNull) =>
        value == null ? defaultIfNull : parseAsNumber(value)

    return {
        e: e.map(e => ({
            id: e.id,
            k: defaultOrParseAsInt(e.k, DEFAULT_TAG.id),
            v: (e.v || []).map(parseAsNumber),
        })),
        mode: defaultOrParseAsInt(mode, DEFAULT_MODE.id),
        day: defaultOrParseAsInt(day, null),
    }
}

const Scans = () => {
    const queryParams = parseQueryParams(useQuery())

    return (
        <div>
            <div className="wrapper wrapper-content">
                <div className="animated fadeIn">
                    <div style={{ marginTop: -15, paddingTop: 0 }}>
                        <div className="row">
                            <div className="col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-12">
                                <GetScansWidget
                                    queryParams={queryParams}
                                    palette={PALETTE}
                                />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-lg-10 col-lg-offset-1 col-md-10 col-md-offset-1 col-sm-12">
                                <GetTagsForScansWidget
                                    queryParams={queryParams}
                                    palette={PALETTE}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Scans
